import { useState } from 'react'
import {
  AppBar as MuiAppBar,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemText,
  Toolbar,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import CloseIcon from '@material-ui/icons/Close'
import classNames from 'classnames'
import useStyles from './styles'
import {
  BABYLIST_URL,
  DME_ZENDESK_URL,
  HOME_PATH,
} from '../../../dme/constants'

export default function AppBar() {
  const classes = useStyles()

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <div className={classes.root}>
      <MuiAppBar className={classes.appBar} elevation={4} position="sticky">
        <Toolbar>
          <Grid container direction="row">
            <Grid item xs>
              <IconButton
                aria-label="menu"
                className={classes.menuButton}
                onClick={() => setIsDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <Button className={classes.linkButton} href={BABYLIST_URL}>
                Babylist
              </Button>
            </Grid>
            <Grid item xs className={classes.title}>
              <Link aria-label="Visit homepage" href={HOME_PATH}>
                <img
                  alt="Babylist Health Logo"
                  src="//res.cloudinary.com/babylist/image/upload/v1662486788/DME/logo_babylist-health.svg"
                />
              </Link>
            </Grid>
            <Grid item xs className={classes.rightGrid}>
              <Button className={classes.linkButton} href={DME_ZENDESK_URL}>
                Help
              </Button>
            </Grid>
          </Grid>

          <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
            <List className={classes.list}>
              <IconButton
                className={classes.closeButton}
                onClick={() => setIsDrawerOpen(false)}
              >
                <CloseIcon />
              </IconButton>
              <ListItem divider component="a" href={DME_ZENDESK_URL}>
                <ListItemText primary="HELP" />
              </ListItem>
            </List>
            <List className={classNames(classes.babylistMenu, classes.list)}>
              <Divider />
              <ListItem component="a" href={BABYLIST_URL}>
                <ListItemText primary="BABYLIST" />
              </ListItem>
            </List>
          </Drawer>
        </Toolbar>
      </MuiAppBar>
    </div>
  )
}
